import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '../Button';
import * as Styled from './AuthBtns.styles';
import { links } from './data';

const AuthBtns = () => {
  const { t } = useTranslation();

  return (
    <Styled.AuthBtns>
      {links.map((link) => (
        <Link key={link.labelKey} to={link.href}>
          <Button variant={link.variant}>{t(link.labelKey)}</Button>
        </Link>
      ))}
    </Styled.AuthBtns>
  );
};

export default AuthBtns;
